/**
 * Enregistrements Wolof natifs — un fichier MP3 continu par rôle, découpé
 * à la lecture via audioStartSec / audioEndSec (voir useNarration.js).
 *
 * Les valeurs sont en secondes avec précision milliseconde (ex. 11.08).
 * Chaque segment inclut une petite marge (début légèrement avancé, fin
 * légèrement repoussée) et un écart aux jonctions partagées pour éviter
 * les coupures brutales.
 *
 * Source : scripts/onboarding/native-wo.timestamps.json
 */

const MASTER = '/onboarding/audio/wo-native';

/** @param {number} startSec @param {number} endSec */
function seg(startSec, endSec) {
  return {
    audioStartSec: startSec,
    audioEndSec: endSec,
    durationMs: Math.round((endSec - startSec) * 1000),
  };
}

/** @type {Record<string, { masterAudioSrc: string, segments: Record<string, ReturnType<typeof seg>> }>} */
export const NATIVE_WO_SEGMENTS = {
  beneficiaire: {
    masterAudioSrc: `${MASTER}/beneficiaire.mp3`,
    segments: {
      welcome: seg(0, 4.68),
      barriers: seg(7.15, 12.34),
      contact: seg(13.71, 18.75),
      support: seg(20.55, 28.60),
      cta: seg(28.76, 32.64),
    },
  },
  parrain_grand: {
    masterAudioSrc: `${MASTER}/parrain_grand.mp3`,
    segments: {
      welcome: seg(0, 4.63),
      influence: seg(4.63, 11.70),
      campaigns: seg(11.70, 22.09),
      finance: seg(22.09, 30.08),
      cta: seg(30.08, 36.50),
    },
  },
  relais_prive: {
    masterAudioSrc: `${MASTER}/relais_prive.mp3`,
    segments: {
      welcome: seg(0, 4.53),
      invited: seg(4.53, 11.38),
      engine: seg(11.38, 16.91),
      guide: seg(17.20, 26.50),
      cta: seg(26.60, 31.27),
    },
  },
  relais_public: {
    masterAudioSrc: `${MASTER}/relais_public.mp3`,
    segments: {
      welcome: seg(0, 3.90),
      chosen: seg(3.90, 10.16),
      visible: seg(10.16, 17.04),
      accompany: seg(19.34, 25.34),
      cta: seg(26.82, 32.05),
    },
  },
};

/**
 * Applique l'audio natif (fichier unique + fenêtre temporelle) aux scènes wolof.
 * @param {string} roleKey
 * @param {Array<object>} scenes
 */
export function applyNativeWoAudio(roleKey, scenes) {
  const cfg = NATIVE_WO_SEGMENTS[roleKey];
  if (!cfg) return scenes;
  return scenes.map((s) => {
    const window = cfg.segments[s.id];
    if (!window) return s;
    return {
      ...s,
      audioSrc: cfg.masterAudioSrc,
      audioStartSec: window.audioStartSec,
      audioEndSec: window.audioEndSec,
      durationMs: window.durationMs,
      timingsSrc: null,
    };
  });
}
